import { TextField } from '@mui/material';
import Grid from 'components/core/Grid';
import styled from 'styled-components';

export const StyledSuggestionsWrapper = styled(Grid)`
  margin-bottom: ${props => props.theme.spacing(3)};
`;

export const StyledTextField = styled(TextField)`
  & .MuiInputBase-root {
    margin-bottom: ${props => props.theme.spacing(3)};
  }

  & fieldset {
    border-bottom: ${props => props.theme.spacing(0.5)} solid ${props => props.theme.palette.secondary.main};
  }

  & .MuiInputLabel-root {
    position: absolute !important;
  }
`;

export const StyledSuggestions = styled.div`
  margin-top: -26px;
  border: 1px solid ${props => props.theme.palette.grey[300]};
  border-top: 0px solid transparent;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  & > div {
    padding: ${props => props.theme.spacing(0.5)} 0px;

    &:not(:first-child) {
      border-top: 1px dashed ${props => props.theme.palette.grey[300]};
    }

    &:hover {
      background-color: ${props => props.theme.layout.lightBackground};
    }
  }

  & li {
    ${props => props.theme.typography.body2};
    font-weight: 500;

    ${props => props.theme.breakpoints.down('sm')} {
      white-space: normal;
    }
  }
`;
